<template>
  <div
    v-loading="loading"
    element-loading-text="加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
    style="display: flex"
  >
    <div class="" style="flex: 2">
      <div class="warm-cont-top">
        <div>
          <div class="warm-cont-top-box">
            <b>设备门状态</b>
            <p></p>
            <div style="display: none">
              {{ devItem.deviceAddr }}
            </div>
            <div class="warm-cont-top-type">
              <div v-if="status">已开启<i></i></div>
              <div v-else>已关闭<i style="background: #ffffff"></i></div>
              <p>状态</p>
            </div>
          </div>
          <div class="warm-cont-top-box">
            <b>单次脉冲采样</b>
            <p></p>
            <div class="warm-cont-top-type">
              <div>{{ pulseCurrent }}%<i></i></div>
              <p>状态</p>
            </div>
          </div>
          <div class="warm-cont-top-box">
            <b>累计脉冲采样</b>
            <p></p>
            <div class="warm-cont-top-type">
              <div>{{ pulseTotal }}%<i></i></div>
              <p>状态</p>
            </div>
          </div>
        </div>
        <div style="margin-top: 40px">
          <div class="warm-cont-top-box">
            <b>光源状态</b>
            <p></p>
            <div class="warm-cont-top-type">
              <div v-if="menuList[0].state">已开启<i></i></div>
              <div v-else>已关闭<i style="background: #ffffff"></i></div>
              <p>状态</p>
            </div>
          </div>
          <div class="warm-cont-top-box">
            <b>吸气口状态</b>
            <p></p>
            <div class="warm-cont-top-type">
              <div v-if="menuList[1].state">已开启<i></i></div>
              <div v-else>已关闭<i style="background: #ffffff"></i></div>
              <p>状态</p>
            </div>
          </div>
          <div class="warm-cont-top-box">
            <b>排气口状态</b>
            <p></p>
            <div class="warm-cont-top-type">
              <div v-if="menuList[2].state">已开启<i></i></div>
              <div v-else>已关闭<i style="background: #ffffff"></i></div>
              <p>状态</p>
            </div>
          </div>
          <div class="warm-cont-top-box">
            <b>载波带电机运行</b>
            <p></p>
            <div class="warm-cont-top-type">
              <div v-if="menuList[3].state">已开启<i></i></div>
              <div v-else>已关闭<i style="background: #ffffff"></i></div>
              <p>状态</p>
            </div>
          </div>
          <div class="warm-cont-top-box">
            <b>采样电机运行</b>
            <p></p>
            <div class="warm-cont-top-type">
              <div v-if="menuList[4].state">已开启<i></i></div>
              <div v-else>已关闭<i style="background: #ffffff"></i></div>
              <p>状态</p>
            </div>
          </div>
          <div class="warm-cont-top-box">
            <b>摄像头</b>
            <p></p>
            <div class="warm-cont-top-type">
              <div v-if="menuList[5].state">已开启<i></i></div>
              <div v-else>已关闭<i style="background: #ffffff"></i></div>
              <p>状态</p>
            </div>
          </div>
        </div>
      </div>
      <div v-if="showSporeList.createTime" class="warm-cont-bottom">
        <!-- <img  :src="showSporeList.imagesUrl" style="width: 298px; height: 298px; margin-right: 20px" alt=""> -->
        <el-image
          style="width: 298px; height: 298px; margin-right: 20px"
          :src="showSporeList.imagesUrl"
          lazy
          :preview-src-list="srcList"
        >
        </el-image>
        <div class="warm-cont-bottom-text">
          <div>采集于：</div>
          {{ showSporeList.createTime }}
        </div>
      </div>
    </div>
    <div class="" style="flex: 1; display: flex; justify-content: flex-end">
      <div style="width: 90%">
        <div class="cx-warm-right-item">
          <div class="cx-warm-right-top">
            <div class="cx-warm-right-img">
              <img
                src="https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1701744536550.png"
                alt=""
              />
            </div>
            <div class="cx-warm-right-text">
              <p>实时孢子</p>
              <p>近日孢子采集数据</p>
            </div>
            <div class="cx-warm-right-hr"></div>
          </div>
          <div class="cx-warm-right-list">
            <div
              v-if="sporeList.length == 0"
              class=""
              style="display: flex; justify-content: center"
            >
              <el-empty
                :image-size="75"
                description="暂无设备"
                image="https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1705376475598.png"
              ></el-empty>
              <!-- cx-warm-right-list-null<img src="https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1702628781853.png" alt="">
							<p>暂无数据</p> -->
            </div>
            <div v-else>
              <div
                v-for="(item, index) in sporeList"
                :key="index"
                @click="chooseItem(item)"
              >
                <!-- <img   :src="item.imagesUrl" :alt="item.imagesUrls" style="width: 72px; height: 72px; margin-right: 20px"> -->
                <el-image
                  style="width: 72px; height: 72px; margin-right: 20px"
                  :src="item.imagesUrl"
                  lazy
                  :preview-src-list="srcList"
                >
                </el-image>
                <div class="cx-warm-right-list-text">
                  {{ item.createTime }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style="margin-top: 5px">
          <div style="display: flex; justify-content: start">
            <div>
              <el-radio-group
                v-model="mapRadio"
                size="mini"
                @change="mapRadioOnChange()"
              >
                <el-radio-button label="标准"></el-radio-button>
                <el-radio-button label="卫星"></el-radio-button>
                <el-radio-button label="3D地图"></el-radio-button>
                <el-radio-button label="3D室内地图"></el-radio-button>
              </el-radio-group>
            </div>
            <div style="width: 40%">
              <el-input
                placeholder="请输入经纬度"
                v-model="mapLat"
                class="input-with-select"
                style=""
              >
                <el-button slot="append" icon="el-icon-search" @click="searchMapLat()"></el-button>
              </el-input>
            </div>
          </div>
        </div>
        <div v-if="mapRadio == '标准'" style="margin-top: 5px">
          <el-radio-group
            v-model="mapRadioType"
            @change="mapRadioTypeOnChange()"
          >
            <el-radio label="normal">标准</el-radio>
            <el-radio label="dark">幻影黑</el-radio>
            <el-radio label="light">月光银</el-radio>
            <el-radio label="whitesmoke">远山黛</el-radio>
            <el-radio label="fresh">草色青</el-radio>
            <el-radio label="grey">雅士灰</el-radio>
            <el-radio label="blue">靛青蓝</el-radio>
            <el-radio label="darkblue">极夜蓝</el-radio>
          </el-radio-group>
        </div>

        <div class="cx-warm-map" :style="mapRadio!='标准'?'height:460px':''" style="margin-top: 15px">
          <div id="container"></div>
        </div>
      </div>
    </div>
    <el-dialog
      title="提示"
      :visible.sync="centerDialogVisible"
      width="30%"
      center
    >
      <span>当前设备暂无数据</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="centerDialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script
  type="text/javascript"
  src="https://webapi.amap.com/maps?v=2.0&key=d5571f8dd4961fc899fa1cef60e294d6&plugin=AMap.CitySearch"
></script>
<script>
export default {
  name: "app",
  components: {},
  props: {
    // 当前活动tab的索引
    devItem: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      mapLat:'',
      mapRadio: "标准",
      mapRadioType: "normal",
      srcList: [],
      beginTime: "",
      endTime: "",
      status: false,
      pulseCurrent: "--",
      pulseTotal: "--",
      menuList: [
        {
          name: "光源状态",
          state: false,
          module: "IamphouseStatus",
        },
        {
          name: "吸气口状态",
          state: false,
          module: "AdmissionPortStatus",
        },
        {
          name: "排气口状态",
          state: false,
          module: "BlowVentStatus",
        },
        {
          name: "载波带电机运行",
          state: false,
          module: "ZBDMotorStatus",
        },
        {
          name: "采样电机运行",
          state: false,
          module: "SamplingPortStatus",
        },
        {
          name: "摄像头",
          state: false,
          module: "photograph",
        },
      ],
      sporeList: [],
      showSporeList: {},
      map: {},
      oldDevItem: {},
      loading: true,
      centerDialogVisible: false,
    };
  },
  mounted() {
    console.log("孢子组件mounted---");
    // 从本地缓存中获取数据
    let userInfo = localStorage.getItem("user_info");
    // 将获取到的JSON字符串转换回对象
    this.userInfo = JSON.parse(userInfo);
    if (this.devItem.deviceAddr) {
      this.init();
    }
  },
  updated() {
    console.log("孢子组件---更新数据重新渲染DOM---devItem", this.devItem);
    this.init();
  },
  beforeDestroy() {
    // console.log(孢子组件---在实例销毁之前调用')
    this.map.options && this.map.destroy();
  },
  methods: {
    init() {
      if (this.oldDevItem.deviceAddr != this.devItem.deviceAddr) {
        if (this.devItem.status == "offline") {
          console.log("孢子组件init===========离线===========");
        } else {
          console.log("孢子组件init======================");
        }
        this.loading = true;
        this.getRealTimeData();
        this.getThirtyData();
        this.oldDevItem = this.devItem;
      } else {
        console.log("孢子组件init重复======================");
      }
    },
    getRealTimeData() {
      //设备数据
      let httpData = {
        deptId: this.userInfo?this.userInfo.deptId:0,
        deviceAddrs: this.devItem.deviceAddr, //"0718230010",
      };
      this.$axios
        .get("/FourEmotions/getRealTimeData", {
          params: httpData,
        })
        .then((res) => {
          console.log("设备数据getRealTimeData-res===", res);
          if (res.data.length != 0) {
            let data = res.data[0].data;

            this.status = res.data[0].status == "online" ? false : true;
            this.pulseCurrent = data.PulseCurrent;
            this.pulseTotal = data.PulseTotal;
            this.menuList[0].state = data.IamphouseStatus == 1 ? true : false;
            this.menuList[1].state =
              data.AdmissionPortStatus == 1 ? true : false;
            this.menuList[2].state = data.BlowVentStatus == 1 ? true : false;
            this.menuList[3].state = data.ZBDMotorStatus == 1 ? true : false;
            this.menuList[4].state =
              data.SamplingPortStatus == 1 ? true : false;
            this.menuList[5].state = data.photograph == 1 ? true : false;
          } else {
            this.centerDialogVisible = true;
          }
          this.map.options && this.map.destroy();
          this.map = {};
          this.newMap();
        })
        .catch((error) => {
          console.log("设备数据getRealTimeData-error===", error);
          if (
            error.msg ==
            "运行时异常:syntax error, pos 1, line 1, column 2访问过于频繁"
          ) {
            this.$message.error("访问过于频繁");
          }
        });
    },
    getThirtyData() {
      // 获取当前时间
      var currentDate = new Date();
      // 获取当前时间30天后的日期
      var futureDate = new Date();
      futureDate.setDate(futureDate.getDate() - 30);
      // 格式化日期为 yyyy-MM-dd HH:mm:ss
      function formatDate(date) {
        var year = date.getFullYear();
        var month = ("0" + (date.getMonth() + 1)).slice(-2);
        var day = ("0" + date.getDate()).slice(-2);
        var hours = ("0" + date.getHours()).slice(-2);
        var minutes = ("0" + date.getMinutes()).slice(-2);
        var seconds = ("0" + date.getSeconds()).slice(-2);
        return (
          year +
          "-" +
          month +
          "-" +
          day +
          " " +
          hours +
          ":" +
          minutes +
          ":" +
          seconds
        );
      }
      // 格式化当前时间和30天后的时间
      this.endTime = formatDate(currentDate);
      this.beginTime = formatDate(futureDate);

      this.sporeList = [];
      this.getDeviceData();
    },
    getDeviceData() {
      //获取实时孢情数据
      let httpData = {
        deptId: this.userInfo?this.userInfo.deptId:0,
        deviceAddr: this.devItem.deviceAddr, //"1028230009",
        beginTime: this.beginTime,
        endTime: this.endTime,
        deviceType: "spore",
      };
      console.log("获取实时孢情数据getDeviceData-httpData===", httpData);
      this.$axios
        .get("/FourEmotions/getDeviceData", {
          params: httpData,
        })
        .then((res) => {
          console.log("获取实时孢情数据getDeviceData-res===", res);
          if (res.data) {
            for (let i in res.data.rows) {
               res.data.rows[i].imagesUrls= res.data.rows[i].imagesUrl;

              res.data.rows[i].imagesUrl = res.data.rows[i].imagesUrl.replace(
              "http://images.auto.0531yun.cn/sporeImages/",
              "https://web.dxnyyun.com/sporeImages/"
            );
              this.showSporeList = res.data.rows[0];
              this.srcList.push(res.data.rows[0].imagesUrl.replace(
              "http://images.auto.0531yun.cn/sporeImages/",
              "https://web.dxnyyun.com/sporeImages/"
            ));
              this.sporeList.push(res.data.rows[i]);
            }
          }
          this.loading = false;
        })
        .catch((error) => {
          console.log("获取实时孢情数据getDeviceData-error===", error);
          this.loading = false;
        });
    },
    chooseItem(item) {
      // console.log('chooseItem===', item);
      this.showSporeList = item;
      this.srcList = [];
      this.srcList.push(item.imagesUrl);
    },
    mapRadioOnChange() {
      this.newMap();
      this.mapRadioType = "normal";
    },
    mapRadioTypeOnChange() {
      console.log("--mapRadioTypeOnChange--", this.mapRadioType);
      var styleName = "amap://styles/" + this.mapRadioType;
      this.map.setMapStyle(styleName);
    },
    searchMapLat() {
      this.newMap();
      this.mapRadioType = "normal";
    },
    newMap() {
      let lngLat = this.mapLat != "" ? this.mapLat.split(",") : [];

      if (lngLat.length > 0) {
        lngLat.push(lngLat[0]);
        lngLat.push(lngLat[1]);
      }
      let scripts = [];
      if (this.mapRadio == "标准") {
        scripts = [
          "https://webapi.amap.com/maps?v=2.0&key=d5571f8dd4961fc899fa1cef60e294d6",
          "https://cache.amap.com/lbs/static/es5.min.js",
        ];
      } else if (this.mapRadio == "卫星") {
        scripts = [
          "https://webapi.amap.com/maps?v=2.0&key=d5571f8dd4961fc899fa1cef60e294d6&plugin=Map3D",
        ];
      } else if (this.mapRadio == "3D地图") {
        scripts = [
          "https://webapi.amap.com/maps?v=2.0&key=d5571f8dd4961fc899fa1cef60e294d6&plugin=AMap.ControlBar",
        ];
      } else if (this.mapRadio == "3D室内地图") {
        scripts = [
          "https://webapi.amap.com/maps?v=2.0&key=d5571f8dd4961fc899fa1cef60e294d6&plugin=AMap.ToolBar",
          "https://webapi.amap.com/demos/js/liteToolbar.js",
        ];
      }

      scripts.forEach((src) => {
        const script = document.createElement("script");
        script.src = src;
        script.onload = () => {
          // 外部 JS 文件加载成功后的回调函数
          // console.log('气象newMap加载成功');

          // 这是中心点的经纬度
          // 业务中应该是获取当前位置
          if (this.mapRadio == "标准") {
            this.map = new AMap.Map("container", {
              resizeEnable: true, //是否监控地图容器尺寸变化
              mapStyle: "amap://styles/fresh",
              zoom: this.mapLat != "" ? 6 : 13, //初始化地图层级
              center: this.mapLat != "" ? lngLat : [103.83, 36.06], // 初始化地图中心点
            });
          } else if (this.mapRadio == "卫星") {
            this.map = new AMap.Map("container", {
              center: this.mapLat != "" ? lngLat : [103.83, 36.06], // 初始化地图中心点
              zoom: this.mapLat != "" ? 14 : 13, //初始化地图层级
              mapStyle: "amap://styles/fresh",
              features: ["road", "bg"],
            });

            let satellite = new AMap.TileLayer.Satellite({
              map: this.map,
            });
          } else if (this.mapRadio == "3D地图") {
            this.map = new AMap.Map("container", {
              resizeEnable: true,
              rotateEnable: true,
              pitchEnable: true,
              zoom: this.mapLat != "" ? 14 : 17, //初始化地图层级
              pitch: 80,
              rotation: -15,
              viewMode: "3D", //开启3D视图,默认为关闭
              buildingAnimation: true, //楼块出现是否带动画

              expandZoomRange: true,
              zooms: [3, 20],
              center: this.mapLat != "" ? lngLat : [103.83, 36.06], // 初始化地图中心点
            });

            this.map.addControl(
              new AMap.ControlBar({
                showZoomBar: false,
                showControlButton: true,
                position: {
                  right: "10px",
                  top: "10px",
                },
              })
            );
          } else if (this.mapRadio == "3D室内地图") {
            this.map = new AMap.Map("container", {
              resizeEnable: true,
              center: this.mapLat != "" ? lngLat : [103.83, 36.06], // 初始化地图中心点
              zoom: this.mapLat != "" ? 14 : 18, //初始化地图层级
              pitch: 50,
              viewMode: "3D",
            });

            this.map.on("indoor_create", function () {
              this.map.indoorMap.showIndoorMap("B000A856LJ", 5);
            });
          }

          if (lngLat.length > 0) {
            // 点标记显示内容，HTML要素字符串
            const markerContent =
              "" +
              '<div class="custom-content-marker">' +
              '   <img src="https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1705998876110.gif">' +
              "</div>";
            let lngLons = lngLat[0];
            let lngLats = lngLat[1];
            const position = new AMap.LngLat(lngLons, lngLats); // Marker经纬度
            const marker = new AMap.Marker({
              position: position,
              content: markerContent, // 将 html 传给 content
              offset: new AMap.Pixel(-13, -30), // 以 icon 的 [center bottom] 为原点
            });
            this.map.add(marker);
          }
          this.loading = false;
        };
        script.onerror = (err) => {
          // 外部 JS 文件加载失败后的回调函数
          // console.log('孢子newMap加载失败', err);
        };
        document.head.appendChild(script);
      });
    },
  },
};
</script>

<!-- <style>
	@import url("https://a.amap.com/jsapi_demos/static/demo-center/css/demo-center.css");
</style> -->
<style>
.warm-cont-bottom-text {
  font-size: 24px;
  color: #ffffff;
}

.warm-cont-bottom-text p {
  margin-bottom: 40px;
}

.warm-cont-bottom-text div {
  margin-bottom: 30px;
}

.warm-cont-bottom img {
  width: 365px;
  height: 348px;
  background: #d8d8d8;
  margin-right: 20px;
}

.warm-cont-bottom {
  display: flex;
  margin-top: 40px;
}

.warm-cont-top-type div {
  font-size: 14px;
  color: #ffffff;
}

.warm-cont-top-type i {
  width: 12px;
  height: 12px;
  background: #18fef0;
  display: inline-block;
  border-radius: 50%;
  margin-left: 20px;
}

.warm-cont-top-type p {
  font-size: 12px;
  color: #c5c5c5;
  line-height: 22px;
}

.warm-cont-top-type {
  /* width: 100%; */
  height: 62px;
  background: rgba(255, 255, 255, 0.08);
  padding: 10px;
}

.warm-cont-top-box > b {
  color: #fff;
  font-size: 18px;
}

.warm-cont-top-box > p {
  font-size: 10px;
  color: #909090;
  padding: 4px 0 8px 0;
}

.warm-cont-top-box {
  width: 130px;
  /* height: 75px; */
  line-height: 19px;
  /* margin-bottom: 25px;
		margin-right: 35px; */
}

.warm-cont-top > div:first-child {
  justify-content: flex-start;
}

.warm-cont-top > div:last-child {
  justify-content: space-between;
}

.warm-cont-top > div {
  /* display: flex;
		flex-wrap: wrap; */
  display: grid;
  grid-template-columns: auto auto auto auto auto auto auto;
  gap: 0 35px;
}

/* 
	.warm-cont-top {
		display: flex;
		justify-content: space-between;
	} */

.custom-content-marker {
  position: relative;
  width: 34px;
  height: 34px;
}

.custom-content-marker img {
  width: 100%;
  height: 100%;
}

#container {
  width: 100%;
  height: 100%;
}

/* 地图 */

.cx-warm-right-list-null {
  width: 100%;
}

.cx-warm-right-list-null img {
  width: 200px !important;
  height: 200px !important;
  margin: 0 auto 0 auto !important;
}

.cx-warm-right-list-null p {
  text-align: center;
  width: 100%;
}

.cx-warm-right-list-text {
  width: calc(100% - 92px);
  font-size: 16px;
  color: #ffffff;
  line-height: 24px;
}

.cx-warm-right-list img {
  width: 72px;
  height: 72px;
  margin-right: 20px;
}

.cx-warm-right-list > div > div {
  display: flex;
  margin-bottom: 21px;
  padding: 0 4px;
  width: 45%;
}

.cx-warm-right-list > div {
  display: flex;
  flex-wrap: wrap;
}

.cx-warm-right-list {
  height: 320px;
  overflow: auto;
  scrollbar-width: thin;
  scrollbar-color: transparent transparent;
  margin-top: 25px;
}

.cx-warm-right-list::-webkit-scrollbar {
  width: 8px;
  background-color: transparent;
}

.cx-warm-right-list::-webkit-scrollbar-thumb {
  background-color: transparent;
}

.cx-warm-right-hr {
  width: 12px;
  height: 40px;
  border-bottom: 3px #18fefe solid;
  margin-left: 3px;
}

.cx-warm-right-text {
  line-height: 44px;
  border-bottom: 1px rgba(255, 255, 255, 0.5) solid;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: calc(100% - 50px);
  height: 40px;
  font-size: 16px;
  font-weight: bold;
}

.cx-warm-right-img {
  width: 34px;
  border-bottom: 3px #fff solid;
  padding: 12px 0 9px 0;
  text-align: center;
}

.cx-warm-right-img img {
  width: 20px;
  height: 20px;
}

.cx-warm-right-top {
  width: 100%;
  height: 40px;
  display: flex;
  background: rgba(0, 0, 0, 0.4);
}

.cx-warm-right-item {
  background: transparent;
}
</style>
